export const API_ENDPOINT = '/api/backend/v1';
export const TEST_ORIGIN = 'http://localhost:3003';
